window.formToJSON = (selector) => {
	const form = {}

	document.querySelector(selector).querySelectorAll('select[name], input[name], textarea[name], button[name]').forEach((el) => {
		const name = el.getAttribute('name')
		if (el.getAttribute('type') == 'checkbox') {
			if (el.checked == true) {
				form[name] = 1
			} else {
				form[name] = 0
			}
		} else if (el.getAttribute('type') == 'radio') {
			if (el.checked == true) {
				form[name] = el.value
			}
        } else if (el.selectedOptions && el.multiple) {
            form[name] = Array.from(el.selectedOptions).map(option => option.value)
		} else if (form[name]) {
			form[name] = form[name] + ',' + el.value
		} else {
			form[name] = el.value
		}
	})

	return form
}

window.formDataFromObject = (data) => {
	const formData = new FormData()
	Object.keys(data).forEach((key) => {
		formData.append(key, data[key])
	})
	return formData
}

window.validateIBAN = (iban) => {
	if (iban.substring(0, 2) == 'NL' && iban.length != 18) {
		return false
	}

	const modulo = (divident, divisor) => {
		let m = 0
		for (let i = 0; i < divident.length; ++i) {
			m = (m * 10 + parseInt(divident.charAt(i))) % divisor
		}
		return m
	}

	if (iban.search(/^[A-Z]{2}/gi) < 0) {
		return false
	}

	iban = iban.substring(4) + iban.substring(0, 4)

	iban = iban.replace(/[A-Z]/g, (match) => {
		return match.charCodeAt(0) - 55
	})

	return parseInt(modulo(iban, 97), 10) === 1
}

window.validateTelefoon = (nummer) => {
	return validateTelefoonVast(nummer) || validateTelefoonMobiel(nummer)
}

window.validateTelefoonVast = (nummer) => {
	if (nummer == '112' || nummer == '144' || nummer.match(/^((116)[0-9]{3})$/) || nummer.match(/^((18)[0-9]{2})$/) || nummer.match(/^((140)([0-9]{2}|[0-9]{3}))$/)) {
		return true
	}

	if (nummer.match(/^((0800|0900|0906|0909)([0-9]{4}|[0-9]{7}))$/)) {
		return true
	} else if (nummer.match(/^((0800|0900|0906|0909)[0-9]{6})$/)) {
		return false
	}

	if (!nummer.match(/^((0|00|\+)[1-9][0-9]+)$/)) {
		return false
	} else if ((nummer.substring(1, 0) == '+' && nummer.substring(3, 0) != '+31') || (nummer.substring(2, 0) == '00' && nummer.substring(4, 0) != '0031')) {
		if (nummer.length < 9) {
			return false
		}
	} else if (!nummer.match(/^((0)([1-5]|[7-8])[0-9]{8})$/) && !nummer.match(/^((\+31)([1-5]|[7-8])[0-9]{8})$/) && !nummer.match(/^((0031)([1-5]|[7-8])[0-9]{8})$/)) {
		return false
	}

	return true
}

window.validateTelefoonMobiel = (nummer) => {
	if (!nummer.match(/^((0|00|\+)[1-9][0-9]+)$/)) {
		return false
	} else if ((nummer.substring(1, 0) == '+' && nummer.substring(3, 0) != '+31') || (nummer.substring(2, 0) == '00' && nummer.substring(4, 0) != '0031')) {
		if (nummer.length < 9) {
			return false
		}
	} else if (!nummer.match(/^((0)(6)[0-9]{8})$/) && !nummer.match(/^((\+31)(6)[0-9]{8})$/) && !nummer.match(/^((0031)(6)[0-9]{8})$/)) {
		return false
	}

	return true
}

window.validateEmailadres = (email) => {
	const regex = /^([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/

	return email.match(regex)
}
